const regex = require("../utilities/regex");

/**
 * Allow user to enter only digits
 * @param {inputSelector} string - Input DOM selector to be validated
 */
const validateInputOnlyDigits = inputSelector => {
    $(inputSelector).on("keydown", event => {
        const isDigit = regex.values.digits.test(event.key);

        if (!isDigit) {
            if (event.keyCode == "8") {
                return;
            } else {
                event.preventDefault();
            }
        }
    });
};

export { validateInputOnlyDigits };
